import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter, Mutation } from 'vuex-class';

@Component({})
export default class CashbackNotification extends Vue {

  @Prop({ default: true }) isOpenCashbackMessage;
  @Prop({ default: true }) showCloseButton;

  @Getter getIsToken;

  @Mutation PATH_TEMPORAL

  _onClose() {
    this.$emit('close-notification');
  }

  _redirectToLogin(option: string) {
    const name = this.$route.name
    const query = this.$route.query
    const params = this.$route.params
    params["modal"] = option

    this.PATH_TEMPORAL({ name, params, query })
    this.$router.push({ name: 'login' })
  }

  _openTyC() {
    window.open('/files/TYC_Atrevete_a_Probar.pdf');
  }

  get showTyC() {
    return this.$route.name && this.$route.name !== 'checkout';
  }
}